// extracted by mini-css-extract-plugin
export default {"backgroundImg":"backgroundImg_JNFLW","titleContainer":"titleContainer_ltpdl","logoBlock":"logoBlock_tSnSS","iconsBlock":"iconsBlock_sIpo-","boxWhithShadow":"boxWhithShadow_j-iId"};